import { render, staticRenderFns } from "./SendCustomNotificationPopup.vue?vue&type=template&id=11efa2c8&scoped=true&"
import script from "./SendCustomNotificationPopup.vue?vue&type=script&lang=ts&"
export * from "./SendCustomNotificationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendCustomNotificationPopup.vue?vue&type=style&index=0&id=11efa2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11efa2c8",
  null
  
)

export default component.exports